export default {
  requestHelper: {
    errors: {
      timeout: 'Request timeout',
      unauthorized: 'Unauthorized',
      other: 'Error while fetching data',
    },
  },
};
